import { render, staticRenderFns } from "./blog-6.vue?vue&type=template&id=f2d771ba&scoped=true"
import script from "./blog-6.vue?vue&type=script&lang=js"
export * from "./blog-6.vue?vue&type=script&lang=js"
import style0 from "./blog-6.vue?vue&type=style&index=0&id=f2d771ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d771ba",
  null
  
)

export default component.exports